import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

import { DynamicContentBookmark } from "./dynamics";

export const Container = styled(ResponsiveContainer)`
  justify-content: center;
  align-items: center;

  inline-size: 24px;
  block-size: 24px;
`;

export type BookmarkProps = {
  $variant?: "default" | "magazines-style";
};

export const StyledContentBookmark = styled(DynamicContentBookmark, {
  ...transientOptions,
})<BookmarkProps>`
  inline-size: 18px;
  block-size: 19px;
  padding: 0;

  path {
    fill: #000000;
    opacity: 1;
  }

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      path[opacity] {
        fill: #d7d7d7;
        opacity: 1;
      }
    `}
`;
